import { CardBaseHeader, Label } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import { TopFiveProps } from './model';
import { DataContainer, RowContainer, TopCard } from './Styles';

export const TopFive = ({ title, data }: TopFiveProps) => {
  const { t } = useTranslation();

  return (
    <TopCard>
      <CardBaseHeader>
        <Label fontSize="14" semibold>
          {t(title)}
        </Label>
      </CardBaseHeader>
      <DataContainer flexDirection="column">
        {data?.map((element, index) => (
          <RowContainer
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            key={index}
          >
            <Label fontSize="12">{!index ? t(element.id) : element.id}</Label>
            <Label fontSize="12">
              {!index ? t('' + element.value) : element.value}
            </Label>
          </RowContainer>
        ))}
      </DataContainer>
    </TopCard>
  );
};
